import React, { useState } from 'react';

import { PaymentMethod as PaymentMethodType } from '@utils/backend-api/stripe';

import EditPaymentMethod from './EditPaymentMethod';
import PaymentMethodHeader from './PaymentMethodHeader';

interface PaymentMethodProps {
  numberOfPaymentMethods: number;
  paymentMethod: PaymentMethodType;
}

const PaymentMethod = ({ numberOfPaymentMethods, paymentMethod }: PaymentMethodProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div
      data-testid="payment-method"
      className="flex flex-col justify-between border-0 border-b border-solid border-grayscale-beige py-32"
    >
      <PaymentMethodHeader
        paymentMethod={paymentMethod}
        setIsExpanded={setIsExpanded}
        isExpanded={isExpanded}
        numberOfPaymentMethods={numberOfPaymentMethods}
      />
      {isExpanded && (
        <EditPaymentMethod
          paymentMethod={paymentMethod}
          numberOfPaymentMethods={numberOfPaymentMethods}
        />
      )}
    </div>
  );
};

export default PaymentMethod;
